
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ListCategoriesService } from './service/list-categories.service';
import { ActivatedRoute } from '@angular/router';
import { CategoriesComponent } from "../categories/categories.component";
import { Category } from '../categories/interfaces/categories.interface';
import { ListSubcategoriesComponent } from "../list-subcategories/list-subcategories.component";
import { Subcategories } from '../subcategorie/interfaces/subcateories.interface';

interface FilterEvent {
  category?: Category | null;
  subcategory?: Subcategories | null;
  categoryId?: number | null;
  subcategoryId?: number | null;
}

@Component({
  selector: 'establishment-main-list-categories',
  imports: [CategoriesComponent],
  templateUrl: './list-categories.component.html',
  styleUrl: './list-categories.component.css'
})
export class ListCategoriesComponent implements OnInit {
  categories: Category[] = [];
  establishmentTypeId: number = 0;
  selectedCategoryId: number | null = null;
  selectedSubcategoryId: number | null = null;
  @Output() filterChanged = new EventEmitter<FilterEvent>();

  constructor(private listCategoriesService: ListCategoriesService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      // console.log('Route params in categories:', params);
      this.establishmentTypeId = +params['id']; // Convert string to number
      // console.log('Establishment Type ID for categories:', this.establishmentTypeId);
      this.getCategories();
    });
  }

  onCategorySelected(categoryId: number | null): void {
    this.selectedCategoryId = categoryId;
    this.selectedSubcategoryId = null; // Reset subcategory when category changes
    // console.log('Category selected:', categoryId);
    this.emitFilterChanged();
  }
  onFilterChange(category: Category | null, subcategory: Subcategories | null) {
    // console.log('onFilterChange called with:', { category, subcategory });
    
    // Actualizar las propiedades locales
    this.selectedCategoryId = category?.pg_id ?? null;
    this.selectedSubcategoryId = subcategory?.ps_id ?? null;
    
    // console.log('Extracted IDs:', { 
    //   categoryId: this.selectedCategoryId, 
    //   subcategoryId: this.selectedSubcategoryId 
    // });
    
    // Emitir el evento con toda la información
    const filterEvent = { 
      category, 
      subcategory,
      categoryId: this.selectedCategoryId,
      subcategoryId: this.selectedSubcategoryId
    };
    
    // console.log('Emitting filterChanged event:', filterEvent);
    this.filterChanged.emit(filterEvent);
  }
  onSubcategorySelected(subcategoryId: number | null): void {
    this.selectedSubcategoryId = subcategoryId;
    // console.log('Subcategory selected:', subcategoryId);
    this.emitFilterChanged();
  }

  private emitFilterChanged(): void {
    this.filterChanged.emit({
      categoryId: this.selectedCategoryId,
      subcategoryId: this.selectedSubcategoryId
    });
  }

  getCategories() {
    // console.log('Calling getCategories with ID:', this.establishmentTypeId);
    this.listCategoriesService.getCategories(this.establishmentTypeId).subscribe(
      (response) => {
        // console.log('Categories API response:', response);
        this.categories = response.data;
        // console.log('Categories loaded:', this.categories);
      },
      (error) => {
        console.error('Error loading categories:', error);
      }
    );
  }
}
